import {
  createAsyncThunk,
  createSlice,
  PayloadAction,
  SerializedError,
} from "@reduxjs/toolkit";
import axios from "axios";
import { API_BASE_URL } from "components/common/ApiUrl";
import { toastError, toastSuccess } from "helpers/toastHelper";
import { RootState } from "redux/store";

interface ReSendOtpState {
  isLoading: boolean;
  error: string | null;
  successMessage: string | null;
}

interface ReSendOtpPayload {
  // hash: string;
  // subdomain: string;
  verificationType: string
  isResend: string;
  email: string
}


const initialState: ReSendOtpState = {
  isLoading: false,
  error: null,
  successMessage: null,
};


// Re-Send otp Async here //
export const reSendOtpAsync = createAsyncThunk<
  string,
  ReSendOtpPayload,
  { rejectValue: { message: string; status: number } }
>(
  "auth/re-sendOtp",
  async (payload, { rejectWithValue }) => {
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const response = await axios.post(
        `${API_BASE_URL}/sent-otp`,
        payload,
        config
      );

      if (response?.data?.success) {
        toastSuccess(response?.data?.message);
        return response?.data?.message;
      } else {
        toastError(response?.data?.message || response?.code);
        return rejectWithValue({ message: response?.data?.message, status: 400 });
      }
    } catch (error: any) {
      const errorMessage =
        error.response?.data?.message;
      toastError(errorMessage);
      return rejectWithValue({
        message: errorMessage,
        status: error.response?.status,
      });
    }
  }
);

// Re-Send otp Slice here //
const reSendOtpSlice = createSlice({
  name: "reSendOtpState",
  initialState,
  reducers: {
    clearReSendOtpError: (state) => {
      state.error = null;
    },
    clearReSendOtpSuccess: (state) => {
      state.successMessage = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(reSendOtpAsync.pending, (state) => {
        state.isLoading = true;
        state.error = null;
        state.successMessage = null;
      })
      .addCase(reSendOtpAsync.fulfilled, (state, action) => {
        state.isLoading = false;
        state.successMessage = action.payload;
      })
      .addCase(reSendOtpAsync.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload?.message || "Failed to resend OTP";
      });
  },
});

// Selectors here //
export const { clearReSendOtpError, clearReSendOtpSuccess } = reSendOtpSlice.actions;
export default reSendOtpSlice.reducer;

export const selectReSendOtpState = (state: RootState) => state.reSendOtpState;
export const selectReSendOtpError = (state: RootState) => state.reSendOtpState.error;
export const selectReSendOtpSuccessMessage = (state: RootState) => state.reSendOtpState.successMessage;
